module.exports = __webpack_public_path__ + "static/img/5.8faca59.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/5.png
// module id = mrU2
// module chunks = 0